import { StateCreator } from 'zustand';
import { InterstitialData, Magazine } from '@/services/datatypes/pdf';

export interface CurrentMagazineZustandSlice {
    magazine: Magazine | null
    interstitialData: InterstitialData[] | null
    currentPage: number
    numberOfPages: number
    prepared: boolean

    updateCurrentMagazine: (newMagazine: Magazine | null) => void
    updatePrepared: (newPrepared: boolean) => void
    updateInterstitialData: (interstitialData: InterstitialData[] | null) => void
    updateCurrentPage: (newCurrentPage: number) => void
    _hasHydrated: boolean;
    setHasHydrated: (state: boolean) => void;
}

export const createCurrentMagazineZustandSlice: StateCreator<CurrentMagazineZustandSlice> = (set, get) => ({
    magazine: null,
    magazineDataForViewer: [],
    interstitialData: null,
    currentPage: 1,
    numberOfPages: 0,
    prepared: false,

    updateCurrentMagazine: (newMagazine: Magazine | null) => {
        //console.log("CurentMagazineZustandSlice.updateCurrentMagazine", newMagazine?.date, newMagazine?.edition);
        set(() => ({ magazine: newMagazine }));
    },
    updatePrepared: (newPrepared: boolean) => {
        //console.log("CurentMagazineZustandSlice.updateCurrentMagazine", newMagazine?.date, newMagazine?.edition);
        set(() => ({ prepared: newPrepared }));
    },
    updateInterstitialData: (interstitialData: InterstitialData[] | null) => set(() => ({ interstitialData: interstitialData })),
    updateCurrentPage: (newCurrentPage: number) => {
        //console.log("CurentMagazineZustandSlice.updateCurrentPage", newCurrentPage);
        set(() => ({ currentPage: newCurrentPage }));
    },

    _hasHydrated: false,
    setHasHydrated: (state: boolean) => set(() => ({ _hasHydrated: state })),
});